import React from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';
import ReferralIcon from '../../../../../utils/icons/referralIcon';

export const BuyGame = ({ ctaColor }: { ctaColor: string }) => {
	return (
		<Flex
			p="16px"
			w="100%"
			flexDirection="column"
			border="1px solid"
			borderColor="rgba(128,128,182,0.3)"
			borderRadius="8px"
		>
			<Flex
				justifyContent="space-between"
				w="100%"
				alignItems="center"
			>
				<Text fontSize="10px">Buy this game</Text>
				<Flex
					align="center"
					gridGap="6px"
				>
					<Text fontSize="8px">Refer and earn</Text>
					<ReferralIcon />
				</Flex>
			</Flex>
			<Flex
				justifyContent="space-between"
				w="100%"
				alignItems="center"
				pt="18px"
			>
				<Flex flexDirection="column">
					<Text
						fontSize="8px"
						color="#797B7E"
					>
						Your cartridges
					</Text>
					<Text
						fontSize="10px"
						fontWeight="600"
					>
						0.00 LUM
					</Text>
				</Flex>
				<Flex
					flexDirection="column"
					textAlign="right"
				>
					<Text
						fontSize="8px"
						color="#797B7E"
					>
						Your balance
					</Text>
					<Text
						fontSize="10px"
						fontWeight="600"
					>
						0 USDC
					</Text>
				</Flex>
			</Flex>
			<Flex
				pt="36px"
				position="relative"
				alignItems="center"
			>
				<Box
					bgColor="#797B7E"
					backgroundImage="/assets/default/default-cover-game.png"
					backgroundSize="cover"
					borderRadius="50%"
					w="36px"
					h="36px"
					zIndex="999999"
					position="absolute"
				/>
				<Flex
					border="1px solid #797B7E"
					borderRadius="4px"
					w="95%"
					h="36px"
					ml="14px"
					position="absolute"
					alignItems="center"
					justifyContent="space-between"
				>
					<Flex
						flexDirection="column"
						pl="32px"
					>
						<Text
							fontSize="8px"
							color="#797B7E"
						>
							Total price
						</Text>
						<Text
							fontSize="10px"
							fontWeight="600"
						>
							12,00 USDC
						</Text>
					</Flex>
					<Box
						ml="24px"
						w="1px"
						h="80%"
						bgColor="#797B7E"
					/>
					<Flex
						justifyContent="space-between"
						mr="10px"
						gridGap="6px"
						align="center"
					>
						<Flex
							bgColor={ctaColor}
							h="12px"
							w="12px"
							justifyContent="center"
							align="center"
							color="white"
							borderRadius="3px"
						>
							-
						</Flex>
						<Text
							fontSize="12px"
							fontWeight="600"
						>
							12,00
						</Text>
						<Flex
							bgColor={ctaColor}
							h="12px"
							w="12px"
							justifyContent="center"
							align="center"
							color="white"
							borderRadius="3px"
						>
							+
						</Flex>
					</Flex>
				</Flex>
			</Flex>
			<Flex
				w="100%"
				pt="32px"
				align="center"
				gap="12px"
			>
				<Flex
					w="100%"
					bgColor={ctaColor}
					borderRadius="3px"
					p="10px"
					flexDirection="column"
					align="center"
					justifyContent="center"
				>
					<Text
						fontSize="10px"
						fontWeight="600"
					>
						Buy this game
					</Text>
				</Flex>
			</Flex>
		</Flex>
	);
};

export default BuyGame;
